interface LoginRegisterIconProps {
	className?: string;
}

export function LoginRegisterIcon({ className }: LoginRegisterIconProps) {
	return (
		<svg
			width="16"
			height="15"
			viewBox="0 0 16 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden="true"
		>
			<path
				d="M14.3333 13.5C10.65 9.05556 4.68 9.05556 1 13.5M11.8333 5.16667C11.8333 7.46785 9.96785 9.33333 7.66667 9.33333C5.36548 9.33333 3.5 7.46785 3.5 5.16667C3.5 2.86548 5.36548 1 7.66667 1C9.96785 1 11.8333 2.86548 11.8333 5.16667Z"
				stroke="#00A878"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
